import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { css } from '@emotion/react';
/**
 * Render thumbnail blurhash image using lazy-loaded `fast-blurhash` implementation.
 */
export const ThumbnailBlurhash = ({ blurhash, decodeBlurHashDI, }) => {
    const canvasRef = useRef(null);
    const [moduleLoaded, setModuleLoaded] = useState(!!decodeBlurHashDI);
    const decodeBlurHashRef = useRef(decodeBlurHashDI);
    useEffect(() => {
        if (blurhash && !moduleLoaded && !decodeBlurHashRef.current) {
            ;
            (async () => {
                decodeBlurHashRef.current = (await import('fast-blurhash')).decodeBlurHash;
                setModuleLoaded(true);
            })();
        }
    }, [blurhash, moduleLoaded]);
    useLayoutEffect(() => {
        if (blurhash && moduleLoaded && canvasRef.current) {
            const canvas = canvasRef.current;
            if (canvas.dataset.blurhash !== blurhash && decodeBlurHashRef.current) {
                canvas.width = 90;
                canvas.height = 160;
                const context = canvas.getContext('2d');
                const pixels = decodeBlurHashRef.current(blurhash, 90, 160);
                const outputImageData = new ImageData(pixels, 90, 160);
                context?.putImageData(outputImageData, 0, 0);
                canvas.dataset.blurhash = blurhash;
            }
        }
    }, [blurhash, moduleLoaded]);
    return blurhash ? (<canvas role="presentation" ref={canvasRef} css={css `
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      `}></canvas>) : null;
};
